import React, { useRef, useEffect } from 'react';
import './MultiSelectDropdown.scss';

export default function MultiSelectDropdown({ 
  options, 
  selectedValues, 
  onToggle, 
  onToggleAll, 
  isOpen, 
  onToggleOpen, 
  label 
}) {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onToggleOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen, onToggleOpen]);

  return (
    <div ref={dropdownRef} className="multi-select-dropdown">
      <button 
        onClick={() => onToggleOpen(!isOpen)}
        className="multi-select-dropdown__button"
      >
        {selectedValues.length === 0 ? `All ${label}` : `${selectedValues.length} ${label} selected`}
      </button>
      {isOpen && (
        <div className="multi-select-dropdown__menu">
          <div className="multi-select-dropdown__header">
            <button 
              onClick={onToggleAll} 
              className="multi-select-dropdown__select-all"
            >
              {options.every(option => selectedValues.includes(option)) ? 'Deselect All' : 'Select All'}
            </button>
          </div>
          {options.map(option => (
            <div 
              key={option} 
              className="multi-select-dropdown__option"
              onClick={() => onToggle(option)}
            >
              <input 
                type="checkbox" 
                checked={selectedValues.includes(option)}
                onChange={() => {}}
                className="multi-select-dropdown__checkbox"
              />
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}